import API from '../../../global/api';


//Action types
export const RECEIVE_USERS= 'RECEIVE_USERS';
export const RECEIVE_ADMINS= 'RECEIVE_ADMINS';
export const RECEIVE_KULIAHS= 'RECEIVE_KULIAHS';



// Request Actions
const recieveUsers = (data) =>( {
    type : RECEIVE_USERS,
    data : data
});

const recieveAdmins = (data) =>( {
  type : RECEIVE_ADMINS,
  data : data
});

const recieveKuliahs = (data) =>( {
  type : RECEIVE_KULIAHS,
  data : data
});

//Api calls
export const getUsers= () => {
    return dispatch => {
    API.get(`/users/get-users`, {
    headers : {
      "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
    }
  })
  .then(res => {
      let data = [];
      data =res.data.data;
      dispatch(recieveUsers(data))
  })
}
};

export const getAdmins = () => {
  return dispatch => {
  API.get(`/admin/get-admins`, {
  headers : {
    "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
  }
})
.then(res => {
    let data = [];
    data =res.data.data;
    dispatch(recieveAdmins(data))
})
}
};

export const getKuliahs = () => {
  return dispatch => {
  API.get(`/getKuliahFinder`, {
  headers : {
    "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
  }
})
.then(res => {
    let data = [];
    data =res.data;
    dispatch(recieveKuliahs(data))
})
}
};